import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ParamsContext } from 'providers/ParamsContext';
import { Button, Dialog, TextField } from '@totalsoft/rocket-ui';
import { GridActionsWrapper } from 'components/common/CommonStyles';

const OfferNegotiationModal = ({ financingStructure, onCloseNegotiationModal, onSaveNegotiation, computeNegotiationInProgress }) => {
  const [t] = useTranslation();

  const [newAmounts, setNewAmounts] = useState(
    financingStructure?.assets?.map(asset => ({ internalId: asset.internalId, amount: asset.amount })) || []
  );

  const onAmountChange = index => value => {
    const updatedAmounts = [...newAmounts];
    updatedAmounts[index] = { ...updatedAmounts[index], amount: value };
    setNewAmounts(updatedAmounts);
  };
  const { cvsChAmount } = useContext(ParamsContext);

  return (
    <Dialog
      open={true}
      maxWidth='md'
      fullWidth
      disableEscapeKeyDown
      onClose={onCloseNegotiationModal}
      title={t('OfferEdit.FinancingStructure.AmountNegotiationModal.Title')}
      content={
        <Grid container style={{ textAlign: 'center' }}>
          <Grid item xs={12} md={12} sm={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>{t('OfferEdit.FinancingStructure.AmountNegotiationModal.AssetName')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.FinancingStructure.AmountNegotiationModal.InitialValue')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.FinancingStructure.AmountNegotiationModal.Currency')}</strong>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.FinancingStructure.AmountNegotiationModal.NewValue')}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{t('OfferEdit.FinancingStructure.AmountNegotiationModal.Currency')}</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {financingStructure?.assets?.map((asset, index) => {
                  return (
                    <TableRow key={financingStructure.documentId}>
                      <TableCell>{asset.assetName}</TableCell>
                      <TableCell>{t('DECIMAL', { number: asset.amount })}</TableCell>
                      <TableCell>{financingStructure.currencyCode}</TableCell>
                      <TableCell></TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          isNumeric
                          value={newAmounts[index].amount}
                          inputProps={{ decimalScale: cvsChAmount, allowNegative: false }}
                          onChange={onAmountChange(index)}
                        />
                      </TableCell>
                      <TableCell>{financingStructure.currencyCode}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      }
      actions={
        <GridActionsWrapper container justifyContent='flex-end'>
          <Grid item>{computeNegotiationInProgress && <CircularProgress />}</Grid>
          <Grid item>
            <Button
              id={'offerFinancingStructure_negotiationModal_saveBtn'}
              disabled={!newAmounts.some(amount => amount) || computeNegotiationInProgress}
              onClick={() => onSaveNegotiation(newAmounts)}
            >
              {t('Save')}
            </Button>
          </Grid>
          <Grid item>
            <Button id={'offerFinancingStructure_negotiationModal_closeBtn'} onClick={onCloseNegotiationModal}>
              {t('Close')}
            </Button>
          </Grid>
        </GridActionsWrapper>
      }
    />
  );
};

OfferNegotiationModal.propTypes = {
  financingStructure: PropTypes.object.isRequired,
  onCloseNegotiationModal: PropTypes.func.isRequired,
  onSaveNegotiation: PropTypes.func.isRequired,
  computeNegotiationInProgress: PropTypes.bool.isRequired
};

export default OfferNegotiationModal;
